import { buildPaginationNav } from "./build_pagination_nav";
import { listAttendees } from "./list_attendees";
import { listQuestions } from "./list_questions";

export const handlePagination = (lists) => {
  let { data, listsPerPage, type, containers } = lists,
    currentPage = 1,
    totalPages = Math.ceil(data.length / listsPerPage),
    { main, pagination } = containers;
  console.log(pagination);
  buildPaginationNav({ currentPage, totalPages, container: pagination });

  createList(data, currentPage, listsPerPage, totalPages, containers, type);
  setTimeout(() => {
    currentPage = handleCurrentPage(
      data,
      currentPage,
      listsPerPage,
      totalPages,
      containers,
      type
    );
  }, 400);
};

function handleCurrentPage(
  data,
  pageNumber,
  listsPerPage,
  totalPages,
  containers,
  type
) {
  let pageButton = document.querySelectorAll(".pagination-button");
  pageButton.forEach((button) => {
    button.addEventListener("click", (e) => {
      let action = e.target.id;

      if (action == "firstPage") {
        pageNumber = 1;
      } else if (action == "nextPage") {
        if (pageNumber < totalPages) {
          pageNumber += 1;
        } else {
          pageNumber = totalPages;
        }
      } else if (action == "previousPage") {
        if (pageNumber > 1) {
          pageNumber -= 1;
        } else {
          pageNumber = 1;
        }
      } else if (action == "lastPage") {
        pageNumber = totalPages;
      }
      // console.log(pageNumber);
      createList(data, pageNumber, listsPerPage, totalPages, containers, type);
    });
  });
}

function createList(
  data,
  currentPage,
  listsPerPage,
  totalPages,
  containers,
  type
) {
  // let { data, currentPage, listsPerPage, totalPages, container, type } = obj;
  updatePageNumbers(currentPage, totalPages, containers);

  let pageStart = (currentPage - 1) * listsPerPage;
  let pageEnd = pageStart + listsPerPage;
  let list = data.slice(pageStart, pageEnd);
  let new_listing = { list, type, containers };
  callUserFunction(new_listing);
  // listAttendees(list, "attendee", container);
}

const callUserFunction = (listing) => {
  let { list, type, containers } = listing;
  switch (type) {
    case "query":
      listQuestions(list, containers.main);
      break;
    case "attendee":
      listAttendees(list, type, containers.main);
      break;
  }
};

function updatePageNumbers(currentPage, totalPages, containers) {
  let { main, pagination } = containers;
  let showPageNumbers = document.getElementById(`${pagination}-pageNums`);
  let showNewPages = `${currentPage} of ${totalPages}`;
  showPageNumbers.innerHTML = "";
  showPageNumbers.innerHTML = showNewPages;
}

function getPageNumber(action, currentPage, totalPages) {
  let page;
  switch (action) {
    case "firstPage":
      page = getFirstPage();
      break;

    case "nextPage":
      page = getNextPage(currentPage, totalPages);
      break;

    case "previousPage":
      page = getPreviousPage(currentPage);
      break;

    case "lastPage":
      page = getLastPage(totalPages);
      break;

    default:
      page = getFirstPage();
      break;
  }
  // console.log("page number:", page);
  return page;
}

// const handleCurrentPage = (currentPage, totalPages) => {
//   let paginationButton = document.getElementById(`${action}`);
//   paginationButton.addEventListener("click", (e) => {
//     let page;
//     console.log("curr page: ", currentPage);
//     // e.preventDefault();
//     switch (action) {
//       case "firstPage":
//         page = getFirstPage();
//         break;

//       case "nextPage":
//         console.log("getting next page");
//         page = getNextPage(currentPage, totalPages);
//         break;

//       case "previousPage":
//         page = getPreviousPage(currentPage);
//         break;

//       case "lastPage":
//         page = getLastPage(totalPages);
//         break;

//       default:
//         page = getFirstPage();
//         break;
//     }

//     return page;
//   });
// };

function getFirstPage() {
  return 1;
}
function getNextPage(num, totalPages) {
  return console.log("getting next page");
  // let cp = parseInt(num);
  // console.log("next page: ", num);
  // if (num < totalPages) {
  //   return (num += 1);
  // } else {
  //   return totalPages;
  // }
  // cp < totalPages ? (cp += 1) : cp == totalPages;
  // console.log("current page: ", cp, "total pages: ", totalPages);
  // return cp;
}
function getPreviousPage(num) {
  return console.log("getting prev page");
  // let cp = parseInt(num);
  // cp > 1 ? (cp -= 1) : (cp = 1);
  // return cp;
}
function getLastPage(totalPages) {
  return console.log("getting last page");
  // return totalPages;
}
